import { useEffect, useRef } from "react";
import { useAuthState, AUTH_PHASE } from "@/contexts/AuthContext";
import {
    clearOrgScopedVolatileState,
    consumeRecoveryReloadFlag,
} from "@/lib/clientStorage";
import { disconnectAllManagedResizeObservers } from "@/lib/resizeObserver";

/**
 * Cross-cutting client cleanup on auth/org transitions.
 */
export function ClientLifecycle() {
    const { activeOrg, authPhase } = useAuthState();
    const prevOrgId = useRef(null);

    useEffect(() => {
        if (consumeRecoveryReloadFlag()) {
            // Successful reload after recovery — volatile state already cleared.
        }
    }, []);

    useEffect(() => {
        const orgId = activeOrg?.id ?? null;
        if (prevOrgId.current != null && prevOrgId.current !== orgId) {
            clearOrgScopedVolatileState();
            disconnectAllManagedResizeObservers();
        }
        prevOrgId.current = orgId;
    }, [activeOrg?.id]);

    useEffect(() => {
        if (authPhase === AUTH_PHASE.ANONYMOUS) {
            disconnectAllManagedResizeObservers();
        }
    }, [authPhase]);

    return null;
}
